import { defineComponent as _defineComponent } from 'vue'
import { Course } from "ag-client-typescript";
import { reactive, watch, onMounted, nextTick, ref } from "vue";
import NewValidatedForm from "./validated_input/NewValidatedForm.vue";
import ValidatedTextInput from "./validated_input/ValidatedTextInput.vue";
import { ValidatedTextInputExposed } from "@/exposed_component_types/validated_text_input_exposed";
import { is_email } from "@/new_validators";

type PropTypes = {
  course: Course;
  max_num_inputs: number;
  min_num_inputs: number;
  value?: string[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'group_members_form',
  props: {
    course: null,
    max_num_inputs: null,
    min_num_inputs: null,
    value: { default: () => [] }
  },
  setup(__props: any, { expose, emit }: { emit: ({
  form_validity_changed: [is_valid: boolean];
  input: [usernames: string[]];
  submit: [usernames: string[]];
}), expose: any, slots: any, attrs: any }) {

const props = __props as { course: Course, max_num_inputs: number, min_num_inputs: number, value: string[] };





const group_members_form = ref<InstanceType<typeof NewValidatedForm>>();
const username_input = ref<ValidatedTextInputExposed[]>([]);

const state = reactive({
  usernames: [] as string[],
});

const initialize = (value: string[]) => {
  if (value.length === 0) {
    state.usernames = Array<string>(props.min_num_inputs).fill(
      props.course.allowed_guest_domain,
    );
  } else {
    state.usernames = value.slice();
  }
};

const add_member = () => {
  state.usernames.push(props.course.allowed_guest_domain);
  nextTick(() => {
    const inputs = username_input.value;
    if (inputs && inputs[state.usernames.length - 1]) {
      inputs[state.usernames.length - 1].focus({ cursor_to_front: true });
    }
  });
};

const submit = () => {
  emit("submit", state.usernames);
};

const reset = () => {
  initialize(props.value);
};

watch(
  () => props.value,
  (new_value: string[], old_value: string[]) => {
    initialize(new_value);
  },
  { deep: true },
);

initialize(props.value);

onMounted(() => {
  const inputs = username_input.value;
  if (inputs && inputs[0]) {
    inputs[0].focus({ cursor_to_front: true });
  }
});

expose({
  state,
  submit,
  reset,
});

return { __sfc: true,props, emit, group_members_form, username_input, state, initialize, add_member, submit, reset, NewValidatedForm, ValidatedTextInput, is_email }
}

})